export const LOAD_COUNTRY = "LOAD_COUNTRY";
export const ADD_COUNTRY = "ADD_COUNTRY";
export const UPDATE_COUNTRY = "UPDATE_COUNTRY";
export const DELETE_COUNTRY = "DELETE_COUNTRY";
export const LOAD_COUNTRY_FAILED = "LOAD_COUNTRY_FAILED";
export const PUBLISH_COUNTRY = "PUBLISH_COUNTRY";
